export default __webpack_public_path__ + "1164b03524300cf2eae2979f7f11e010.ttf";